import type { User } from "types/UserZendesk";
import { searchUsers, zafClient } from "@services/Zendesk";
import { useState } from "react";

export function useUserExistenceCheck(selectedUser: User | null) {
    const [existUser, setExistUser] = useState<User | null>(null);
    const [existUserEmail, setExistUserEmail] = useState<User | null>(null);
    const [isChecking, setIsChecking] = useState(false);

    const checkUserExists = async (field: string, value: string) => {
        if (!value || !selectedUser) return { exists: false, user: null };

        try {
            setIsChecking(true);
            const response = await searchUsers(zafClient, `${field}:${value}`);
            const otherUser = response.find(user => user.id !== selectedUser.id);
            return { exists: !!otherUser, user: otherUser };
        } catch (error) {
            console.error(`Error checking ${field}:`, error);
            return { exists: false, user: null };
        } finally {
            setIsChecking(false);
        }
    };

    const checkCpfExists = async (cpf: string) => {
        if (cpf.length !== 11) return { exists: false, user: null };
        const result = await checkUserExists('cpf_3', cpf);
        setExistUser(result.user ?? null);
        return result;
    };

    const checkEmailExists = async (email: string) => {
        const result = await checkUserExists('email', email);
        setExistUserEmail(result.user ?? null);
        return result;
    };

    return {
        existUser,
        existUserEmail,
        isChecking,
        checkCpfExists,
        checkEmailExists,
        setExistUser,
        setExistUserEmail
    };
}